import { render, staticRenderFns } from "./ProductSection.vue?vue&type=template&id=3965b01e&"
import script from "./ProductSection.vue?vue&type=script&lang=js&"
export * from "./ProductSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductSection.vue?vue&type=style&index=0&id=3965b01e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports